// src/pages/legal/Privacy.jsx  或 src/pages/Privacy.jsx
import React from "react";
import "../styles/Auth.css";
import logo from "../assets/logo.png";
import { motion } from "framer-motion";
import AuthNav from "../components/AuthNav";

export default function Privacy() {
  return (
    <div className="auth-background">
      {/* 顶部导航：Members / About */}
      <AuthNav />

      <motion.div
        className="auth-page-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.35 }}
      >
        {/* Logo 区域 */}
        <div className="logo-container">
          <img src={logo} alt="Riceroma Logo" className="auth-logo" />
        </div>

        {/* 内容卡片：和 About 同一风格 */}
        <div
          className="card"
          style={{
            maxWidth: "760px",
            margin: "0 auto 8px",
            padding: "28px 24px",
          }}
        >
          <h2
            style={{
              color: "#d77b00",
              fontSize: "22px",
              marginBottom: "16px",
              letterSpacing: "0.5px",
              textAlign: "center",
            }}
          >
            Privacy Policy / 隐私政策
          </h2>

          {/* 英文部分 */}
          <section
            style={{
              marginBottom: "18px",
              borderBottom: "1px solid #f0f0f0",
              paddingBottom: "14px",
            }}
          >
            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                marginBottom: "8px",
                color: "#333",
              }}
            >
              1. What data we collect
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444" }}>
              We collect only the information necessary to provide our
              membership service, such as your name, email address and basic
              order history. We do not sell your data to any third party.
            </p>

            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                margin: "12px 0 8px",
                color: "#333",
              }}
            >
              2. How we use your data
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444" }}>
              Your data is used to manage your membership status, send service
              emails (such as payment confirmations) and improve our products
              and operations.
            </p>

            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                margin: "12px 0 8px",
                color: "#333",
              }}
            >
              3. Data storage & security
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444" }}>
              Riceroma uses reputable cloud providers in North America
              (Firestore NAM5 region). Access to customer data is restricted to
              authorized team members only.
            </p>
          </section>

          {/* 中文部分 */}
          <section>
            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                marginBottom: "8px",
                color: "#333",
              }}
            >
              1. 我们收集哪些信息
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444" }}>
              为了提供会员服务，我们只会收集必要的信息，例如：姓名、邮箱、会员状态与基础订单记录。
              我们不会向任何第三方出售您的个人信息。
            </p>

            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                margin: "12px 0 8px",
                color: "#333",
              }}
            >
              2. 这些信息将如何使用
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444" }}>
              我们会使用这些信息来：管理会员资格、发送服务相关邮件（例如付款确认、到期提醒），以及统计和优化产品与运营。
            </p>

            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                margin: "12px 0 8px",
                color: "#333",
              }}
            >
              3. 数据存储与安全
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444" }}>
              饭美丽使用位于北美的数据中心（Firestore NAM5 区域）存储数据，只有经过授权的内部成员可以访问相关信息，
              并会尽可能采取合理措施保护数据安全。
            </p>

            <p
              style={{
                fontSize: 13,
                lineHeight: 1.7,
                color: "#777",
                marginTop: "14px",
              }}
            >
              如对隐私有任何问题或请求（例如查阅、更新或删除数据），请通过 About / Contact
              页面中的邮箱与我们联系。
            </p>
          </section>
        </div>
      </motion.div>
    </div>
  );
}